export const SNHU_SHOW_ONB_QUERYPARAM = 'show-onb'
